var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 19.67-4.8 2.12q-1.143.501-2.171-.192Q4 20.907 4 19.64V4.356q0-.972.671-1.664A2.17 2.17 0 0 1 6.286 2h11.428q.943 0 1.615.692.67.692.671 1.664V19.64q0 1.266-1.029 1.958-1.029.693-2.171.192zm0-2.592 5.714 2.533V4.356H6.286V19.61zm0-12.722H6.286h11.428z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOutline);
export default __webpack_public_path__ + "static/media/bookmark_outline.31d78cdf8feb60198c50e6db39bf858d.svg";
export { ForwardRef as ReactComponent };